export function formatFCFA(value) {
  const n = Number(value || 0);
  return `${new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(n)} FCFA`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { year: "numeric", month: "2-digit", day: "2-digit" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("fr-FR", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

// Prevent CSV formula injection (SEC-002): prefix an apostrophe when the value
// starts with a formula character so spreadsheets treat the cell as text.
export function csvSafe(value) {
  if (value === null || value === undefined) return "";
  let s = String(value);
  if (s.length && (s[0] === "=" || s[0] === "+" || s[0] === "-" || s[0] === "@" || s[0] === "\t" || s[0] === "\r")) {
    s = "'" + s;
  }
  // Also neutralise the delimiter so a malicious name can't break out of its cell.
  return s.replaceAll(";", ",");
}
